import { useFormikContext } from 'formik';
import { IQuickVideoForm } from 'lib/api/quickVideo/types';
import { TextEditor } from 'lib/components/textEditorAutomotive';
import { prepareTextForSMS } from 'lib/utils/functions';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components/macro';

const smsEditorToolbar = {
  options: [],
};

export const CustomizeSMSContent = () => {
  const { t } = useTranslation();
  const { values, setFieldValue, errors } = useFormikContext<IQuickVideoForm>();
  const theme = useTheme();

  return (
    <TextEditor
      onTextEditorChange={text => {
        const updatedText = prepareTextForSMS(text);
        setFieldValue('smsText', updatedText);
      }}
      toolbar={smsEditorToolbar}
      addVariableButtonType='button'
      initialContent={values.smsText}
      height='200px'
      showCharacterCounter
      showMagicButton
      magicBtnLabel={t('Script Assist')}
      error={errors.smsText as string}
      extendStyles={{
        wrapper: {
          width: '841px',
        },
        variableButton: {
          height: '40px',
          backgroundColor: theme.colors.white[100],
        },
        variableButtonContainer: {
          margin: '0 0 0 auto',
        },
      }}
    />
  );
};
